<template>
    <div id="FuelPriceLog">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> Fuel Price Log</div>
                    <div class="web-action-btn">
                        <div class="btn-groups">
                            <button id="addActivitytBtn" v-on:click.prevent="addPriceLog()" v-if="!ifAddEnabled" class="btn btn-primary"><i class="fp-add"> </i>Add</button>
                        </div>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content program-asset-list">
                        <section class="internal-container border-top-table-fl" v-if="ifAddEnabled">
                            <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="fuelPriceLogCreate">
                                <div class="form-row">
                                    <div class="col-2 form-group">
                                        <label class="control-label require" for="capacity">Base Price:</label>
                                        <input type="number" class="form-control" v-model="base_price" id="base_price" placeholder="Enter Base Price" name="base_price" @keypress="isAmountCheck($event)">
                                        <div class="field-error">{{base_price_error_msg}}</div>
                                    </div>
                                    <div class="col-4 form-group">
                                        <label class="control-label require" for="unit_id">Location:</label>
                                        <v-select v-model="location" name="location" placeholder="Select Location"
                                                    label="text"
                                                    :options="locationArr">
                                        </v-select>
                                        <div class="field-error">{{ location_error_msg }}</div>
                                    </div>
                                    <div class="col-2 form-group">
                                        <label class="control-label" for="capacity">&nbsp;</label>
                                        <div class="btn-groups">
                                            <button type="submit" id="createFuelPriceBtn" v-if="activeId > 0" class="btn btn-primary" v-on:click.prevent="CreateFuelPriceLog" >
                                            <i class="fp-reload"> </i>  Update
                                            </button>
                                            <button type="submit" id="createFuelPriceBtn" v-else class="btn btn-primary" v-on:click.prevent="CreateFuelPriceLog" >
                                            <i class="fp-save"> </i>  Save
                                            </button>
                                            <button type="submit" id="cancelFuelPriceBtn" class="btn btn-tertiary" v-on:click.prevent="hideAddForm" >
                                            <i class="fp-close"> </i>  Cancel
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                
                            </form>
                        </section>
                        <data-table-filter-config :moduleName="'fuelPriceLogList'" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <section class="data-table bg-white">
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange" :moduleName="'fuelPriceLogList'" :position="'top'">
                                </custom-pagination>
                                <vue-good-table
                                    ref="listFuelPriceLogTable"
                                    mode="remote"
                                    title="Fuel Price Log"
                                    @on-page-change="onPageChange"
                                    @on-selected-rows-change="selectionChanged"
                                    @on-column-filter="onColumnFilter"
                                    @on-per-page-change="onPerPageChange"
                                    @on-sort-change="onSortChange"
                                    :totalRows="totalRecords"
                                    :columns="userColumns"
                                    :rows="rows"
                                    :pagination-options="{
                                        enabled: false,
                                        position: 'both',
                                        perPage: perPage,
                                        perPageDropdown:dropDownPerPage,
                                        dropdownAllowAll: false,
                                    }"
                                    :select-options="{
                                    enabled: true,
                                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                    selectionInfoClass: 'custom-class',
                                    selectionText: 'rows selected',
                                    clearSelectionText: 'clear',
                                    }"
                                    :search-options="{
                                    enabled: false,
                                    }">

                                    <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                        <div :key="key">
                                            <div v-if="props.column.field == 'action'">
                                                <template>
                                                    <a href="javascript:void(0)" title="Edit Price Log" class="fp-edit" v-on:click="updatePriceLog(props.row)"></a>
                                                </template>
                                            </div>
                                            <div v-else>
                                                {{props.formattedRow[props.column.field]}}
                                            </div>
                                        </div>
                                    </template>

                                    <div slot="selected-row-actions">
                                        <button id="deleteProgramAssetBtn" v-on:click.prevent="fuelPriceLogDelete" class="btn btn-danger">Delete</button>
                                    </div>
                                </vue-good-table>
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange">
                                </custom-pagination>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>

import Vue from "vue";


import EventBus from "././event-bus";


import {commonMixins} from '../mixins/commonMixins';
import {contractMixins} from '../mixins/contractMixins';
import {dataTableMixins} from '../mixins/dataTableMixins';

    export default {
        name: "ProgramList",
        metaInfo() {
            return {title: "Fuel Price Log | " +process.env.COPYRIGHT_NAME}
        },
        mixins:[commonMixins,dataTableMixins,contractMixins],
        data: () => ({
            firstLoad: 0,
            permissions: [],
            cantAccessPage: "",
            userColumns:[],
            columns: [
                {
                    label: 'Actions',
                    field: 'action',
                    hidden:false,
                    sortable: false,
                },
                 {
                    label: 'Location',
                    field: 'location',
                    filterable: true,
                    fpFieldType:"option",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Location", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Base Price',
                    field: 'base_price',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"integer",
                    type:'number',
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Asset Group", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Created By',
                    field: 'created_by',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Description", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Created At',
                    field: 'created_at',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"date",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Manufacturer", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Updated By',
                    field: 'updated_by',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Description", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Updated At',
                    field: 'updated_at',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"date",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Manufacturer", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
            ],
            rows: [],
            totalRecords: 0,
            loading:false,
            action:'list',
            ifAddEnabled:false,
            base_price:'',
            location:'',
            locationArr:[],
            base_price_error_msg:'',
            location_error_msg:'',
            activeId:0
        }),
        watch:{

            //check permission change
            permissions: function (permissions) {

                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'list_fuel_drop') {
                            self.cantAccessPage = true;
                        }
                    }
                }

            }

        },
        created: function() {

        },
        mounted: function() {
            var self = this;

            //self.loadList();
            self.getPermissions();
            self.loadFieldData(['location']);
        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.listFuelPriceLogTable.unselectAllInternal();
            },
            addPriceLog:function(){
                var self = this;
                self.location = '';
                self.base_price = '';
                self.base_price_error_msg = '';
                self.location_error_msg = '';
                self.ifAddEnabled = false;
                self.activeId = 0;
                self.ifAddEnabled = true;
            },
            updatePriceLog:function(obj){
                var self = this;
                self.activeId = obj.id;
                self.location = {text:obj.location,value:obj.location_id};
                self.base_price = obj.orig_base_price;
                self.ifAddEnabled = true;
            },
            CreateFuelPriceLog:function(){
                var self = this;

                self.location_error_msg = '';
                self.base_price_error_msg = '';
                var error = false;
                if (self.base_price == '' || self.base_price == null || self.base_price == 0){
                    self.base_price_error_msg = 'Base Price is Required';
                    error = true;
                }

                if (self.location == '' || self.location == null || !self.location.value){
                    self.location_error_msg = 'Location is Required';
                    error = true;
                }

                if (error == true){
                    return;
                }

                $.ajax({
                    url: process.env.ROOT_API + "/fuel-price-log/create",
                    type: "POST",
                    headers: this.ajxHeaders,
                    dataType: "json",
                    data:{
                        location:self.location.value,
                        base_price:self.base_price,
                        id:self.activeId
                    },
                    success: function (data) {
                        self.loading = false;
                        // console.log(data);
                        if (data.status == "success") {
                            self.loadList();
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'fuel-price-log-list')
                    }
                });

            },

            hideAddForm:function(){
                var self = this;
                self.location = '';
                self.base_price = '';
                self.base_price_error_msg = '';
                self.location_error_msg = '';
                self.ifAddEnabled = false;
                self.activeId = 0;
            },

            selectionChanged(param) {
                var self = this;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
                // console.log(self.computed.selectedRows);
                // var rowData = self.$refs['my-table'].selectedRows;
                // console.log(rowData);
            },
            loadListAsset:function(flag){
                var self = this;
                self.activeFlag = flag;
                self.loadList();
            },

            loadList() {
                var self = this;
                var path = window.location.pathname;
                var segments = path.split("/");

                var data = this.$refs['listFuelPriceLogTable'].selectedRows;
                var selectedRows = [];

                for (var i = 0; i < data.length; i++) {
                    selectedRows.push(self.$refs['listFuelPriceLogTable'].selectedRows[i].id)
                }
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    sort: self.serverParams.sort,
                    flag:self.activeFlag,
                    action:self.action,
                    selectedRows:selectedRows,
                    all:false
                };
                self.firstLoad = 1;
                self.loading = true;

                $.ajax({
                    url: process.env.ROOT_API + "/fuel-price-log/list",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        // console.log(data);
                        self.ifAddEnabled = false;
                        if (data.status == "success") {
                            self.activeId = 0;
                             if ( self.action == "delete" ) {
                                self.action = "list";
                                self.loadList();

                            }else{
                                self.rows = data.content.row;
                                self.totalRecords = data.content.totalRecords;
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'fuel-price-log-list')
                    }
                });
            },

            fuelPriceLogDelete() {
              var self = this;
              self.$swal({
                    title: 'Are you sure that you want to delete this Log?',
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    showCloseButton: false,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                      this.action = "delete";
                      this.loadList();

                    } else {
                      console.log("no");
                    }
                });
            },
        }
    };
</script>




// WEBPACK FOOTER //
// src/components/FuelPriceLog.vue